import { QueryState } from 'src/app/core/models/query.model';
import { createTokenQueryServiceInstance } from 'src/app/core/services/query.service';
import { SignalStoreConfig } from 'src/app/shared/functions/store.functions';
import { IIstatComune } from './istat-comuni.model';
import { ITableColumn } from 'src/app/core/models/table.model';

export const ISTATCOMUNI_ENDPOINT = 'istat-comuni';
export const ISTATCOMUNI_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(ISTATCOMUNI_ENDPOINT);

export const istatComuniStateConfig: SignalStoreConfig<QueryState<IIstatComune>> = {
  initState: {
    list: [],
    sort: {
      field: 'denominazione',
      direction: 'asc'
    },
  }
}

export const ISTATCOMUNI_COLUMNS: ITableColumn[] = [
  {
    name: 'istatRegione',
    label: 'ISTAT Regione',
    field: 'istatRegione',
    visible: false
  },
  {
    name: 'denominazioneRegione',
    label: 'Regione',
    field: 'denominazioneRegione',
  },
  {
    name: 'istatComune',
    label: 'Codice ISTAT',
    field: 'istatComune',
  },
  {
    name: 'denominazione',
    label: 'Denominazione',
    field: 'denominazione',
  },
  {
    name: 'siglaAutomobolistica',
    label: 'Provincia',
    field: 'siglaAutomobolistica',
  },
  {
    name: 'codiceCatastale',
    label: 'Codice Catastale',
    field: 'codiceCatastale',
  },
];
